import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { useIsCollapsed } from "~/hooks/useIsCollapsed";
import { CommentStatic } from "./CommentStatic";

interface Props {
  children: ReactNode;
}

export const LaurenQuoteDesktop: FC<Props> = ({ children }) => {
  const isCollapsed = useIsCollapsed();
  const component = !isCollapsed && (
    <Flex position="relative" w="full">
      <Flex maxW="14.75rem" position="absolute" right="-16rem" top="0">
        <CommentStatic color="th.gray4">{children}</CommentStatic>
      </Flex>
    </Flex>
  );

  return component;
};
